import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const routes: Routes = [
  // Ruta de autenticación
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        title: 'Inicio de sesión',
        loadComponent: () =>
          import('./features/auth/components/login/login.component'),
        canActivate: [guestGuard],
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },

  {
    path: '',
    pathMatch: 'full',
    title: 'Comparamotors - Tu portal automotriz',
    loadComponent: () => import('./landing/landing.component'),
  },
  {
    path: 'landing',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'category/:id',
    title: 'Categoría',
    loadComponent: () =>
      import('./landing/pages/category-page/category-page.component').then(
        (c) => c.CategoryPageComponent,
      ),
  },
  {
    path: 'article/:slug',
    title: 'Leer Noticia',
    loadComponent: () =>
      import('./landing/pages/article-page/article-page.component').then(
        (c) => c.ArticlePageComponent,
      ),
  },
  {
    path: 'terms',
    title: 'Términos y Condiciones - ComparaMotors',
    loadComponent: () =>
      import('./landing/pages/terms-page/terms-page.component').then(
        (c) => c.TermsPageComponent,
      ),
  },
  {
    path: 'privacy',
    title: 'Política de Privacidad - ComparaMotors',
    loadComponent: () =>
      import('./landing/pages/privacy-page/privacy-page.component').then(
        (c) => c.PrivacyPageComponent,
      ),
  },
  {
    path: 'cookies',
    title: 'Política de Cookies - ComparaMotors',
    loadComponent: () =>
      import('./landing/pages/cookies-page/cookies-page.component').then(
        (c) => c.CookiesPageComponent,
      ),
  },
  {
    path: 'terminos-y-condiciones',
    redirectTo: 'terms',
    pathMatch: 'full',
  },
  {
    path: 'politica-de-privacidad',
    redirectTo: 'privacy',
    pathMatch: 'full',
  },
  {
    path: 'politica-de-cookies',
    redirectTo: 'cookies',
    pathMatch: 'full',
  },
  {
    path: 'about-us',
    title: 'Quiénes Somos',
    loadComponent: () =>
      import('./landing/pages/about-page/about-page.component').then(
        (c) => c.AboutPageComponent,
      ),
  },
  {
    path: 'quienes-somos',
    redirectTo: 'about-us',
    pathMatch: 'full',
  },

  // Rutas principales con main layout
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component'),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (c) => c.default,
          ),
      },
      {
        path: 'categories',
        title: 'Categorías',
        loadComponent: () =>
          import('./features/categories/categories.component'),
      },
      {
        path: 'brands',
        title: 'Marcas',
        loadComponent: () =>
          import('./features/brands/components/list-brands/list-brands.component'),
      },
      {
        path: 'news',
        title: 'Noticias',
        loadComponent: () =>
          import('./features/news/components/news-container/news-container.component'),
        children: [
          {
            path: 'list',
            title: 'Lista de Noticias',
            loadComponent: () =>
              import('./features/news/components/news-list/news-list.component'),
          },
          {
            path: 'create',
            title: 'Crear Noticia',
            loadComponent: () =>
              import('./features/news/components/news-form/news-form.component'),
          },
          {
            path: 'edit/:id',
            title: 'Editar Noticia',
            loadComponent: () =>
              import('./features/news/components/news-form/news-form.component'),
          },
          {
            path: 'multimedia/:id',
            title: 'Editar Multimedia',
            loadComponent: () =>
              import('./features/news/components/news-multimedia-editor/news-multimedia-editor.component'),
          },
        ],
      },
      {
        path: 'users',
        title: 'Usuarios',
        loadComponent: () => import('./features/users/users.component'),
      },
      {
        path: 'synchronize',
        title: 'Sincronizar',
        loadComponent: () =>
          import('./features/synchronize/components/video-list/video-list.component').then(
            (c) => c.default,
          ),
      },
      {
        path: 'versus',
        title: 'Comparaciones VS',
        loadComponent: () =>
          import('./features/versus/components/versus-manager.component').then(
            (c) => c.VersusManagerComponent,
          ),
      },
      {
        path: 'security',
        title: 'Seguridad',
        loadComponent: () => import('./features/security/security.component'),
        children: [
          {
            path: '',
            redirectTo: 'permisos',
            pathMatch: 'full',
          },
          {
            path: 'permisos',
            title: 'Lista de Permisos',
            loadComponent: () =>
              import('./features/security/components/permisos/permisos.component'),
          },
          {
            path: 'roles',
            title: 'Lista de Roles',
            loadComponent: () =>
              import('./features/security/components/roles/roles.component'),
          },
        ],
      },
    ],
  },

  {
    path: 'data-table',
    title: 'table',
    loadComponent: () =>
      import('./shared/components/data-table/data-table.component'),
  },

  // Redirecciones de compatibilidad
  {
    path: 'login',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },

  // Ruta por defecto para rutas no encontradas (redirecciona a inicio en vez de forzar login)
  {
    path: '**',
    redirectTo: '',
  },
];
